import React, { createContext, useContext, useEffect, useState } from 'react';
import { locationSocket, notificationSocket } from '@/api/client/socket';
import { useAuth } from './AuthProvider';

const SocketContext = createContext({ isConnected: false });

export const SocketProvider = ({ children }: { children: React.ReactNode }) => {
  const { user } = useAuth();
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    if (!user) {
      locationSocket.disconnect();
      notificationSocket.disconnect();
      return;
    }

    // Connect both namespaces
    locationSocket.connect();
    notificationSocket.connect();

    const onConnect = () => setIsConnected(true);
    const onDisconnect = () => setIsConnected(false);

    locationSocket.on('connect', onConnect);
    locationSocket.on('disconnect', onDisconnect);

    // Global Notification Listener
    notificationSocket.on('new_notification', (data) => {});

    return () => {
      locationSocket.off('connect', onConnect);
      locationSocket.off('disconnect', onDisconnect);
      notificationSocket.off('new_notification');
      locationSocket.disconnect();
      notificationSocket.disconnect();
    };
  }, [user]);

  return (
    <SocketContext.Provider value={{ isConnected }}>
      {children}
    </SocketContext.Provider>
  );
};
